<template>
  <AdminSystemDetailPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminSystemDetailPage from "shared-ui/pages/AdminSystemDetailPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_systems.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
